import React from 'react';
import { Menu, Dropdown, MenuProps } from 'antd';

const menuStyles: React.CSSProperties = {
  backgroundColor: 'var(--color-primary)',
  color: 'white',
  borderRadius: '8px',
};

const menuItemStyles: React.CSSProperties = {
  color: 'white',
};

interface ContextMenuProps {
  visible: boolean;
  x: number;
  y: number;
  onClick: MenuProps['onClick'];
  setVisible: (visible: boolean) => void;
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  visible,
  x,
  y,
  onClick,
  setVisible,
}) => {
  if (!visible) return null;

  const menu = (
    <Menu
      onClick={onClick}
      style={menuStyles}
      items={[
        { label: <span style={menuItemStyles}>Editor</span>, key: 'editor' },
        { label: <span style={menuItemStyles}>Page View</span>, key: 'pageview' },
      ]}
    />
  );

  return (
    <Dropdown overlay={menu} open={visible} trigger={['click']}>
      <>
        <div style={{ position: 'absolute', left: x, top: y }} />
        <div
          style={{
            inset: 0,
            position: 'fixed',
            top: 0,
            left: 0,
            background: 'rgba(0, 0, 0, 0.05)',
          }}
          onClick={() => setVisible(false)}
        />
      </>
    </Dropdown>
  );
};

export default ContextMenu;
